module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.supplier.index.title')) + " (" + _vm._s(_vm.suppliers.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  })], 1), _vm._v(" "), _c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.suppliers.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.supplier.noDataMsg')) + "\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'supplier.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.supplier.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.suppliers.items), function(p, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "wide": true
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editSupplier(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editSupplierNewTab(p)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "full-w flex wrap client-title-container margin-b-10"
    }, [_c('img', {
      staticClass: "client-img margin-b-10",
      attrs: {
        "src": require("./../../../../../assets/images/client.jpg"),
        "alt": ("$" + (p.name))
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(((p.number) + " - " + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.name')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.name || '-'))])], _c('br'), _vm._v(" "), (p.contact.phonenumber || p.contact.mobilenumber) ? [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.phone')) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.contact.phonenumber))]), _vm._v("\n            " + _vm._s((p.contact.phonenumber && p.contact.mobilenumber) ? ' / ' : '') + "\n            "), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.contact.mobilenumber))]), _c('br')] : _vm._e(), _vm._v(" "), _c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.email')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.contact.email || '-'))]), _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.streetName1')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.address.streetName1 || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.city')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.address.city.name || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.country')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.address.country.name || '-'))])], _c('br')], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('v-table', {
    attrs: {
      "list": _vm.suppliersListView,
      "noDataMessage": _vm.$t('static.defaultText.supplier.noDataMsg'),
      "link": _vm.editSupplier,
      "linkKey": "number",
      "rowKey": "id",
      "translation": "static.supplier.table"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.suppliers.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0088be12","hasScoped":true}!./src/app/pages/withNavigation/supplier/index/index.html
// module id = 2890
// module chunks = 1